import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Button } from '../../../../components';

const ErrorModal = ({ isOpen, onClose, error = {} }) => {
	let message = 'The following error was reported:';
	let errorMessage;
	if (error.name === 'NotAllowedError') {
		message = 'One or more permissions has been denied. Please verify that you\'ve given CareConvene.com access to your camera and microphone in your browser settings.';
	} else {
		errorMessage = error.message;
	}
	return (
		<Modal isOpen={isOpen} contentLabel="Unable to Connect" className="modal-dialog">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">Unable to Connect</h3>
					</div>
				</div>
				<div className="modal-body">
					<p>{message}</p>
					{errorMessage && (
						<React.Fragment>
							<pre>{errorMessage}</pre>
							<p>Please consider doing a Network Test to help diagnose the issue:</p>
							<p><a href="https://networktest.twilio.com/" target="_blank" rel="noreferrer">Network Test</a></p>
						</React.Fragment>
					)}
				</div>
				<div className="modal-footer">
					<Button
						title="Close"
						onClick={onClose}
						large
						primary
					/>
				</div>
			</div>
		</Modal>
	);
};

ErrorModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	error: PropTypes.object
};

export default ErrorModal;
